import styled from "styled-components";

export const TpvSection = styled.div`
      width: 100%;
    display: flex
;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
  /* height: 100%; */
  /* display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center; */
`;

export const TpvWrapper = styled.div`
  width: 100%;
  min-height: 450px;
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center; 
`;

export const TpvHeader = styled.div`
    height: 100%;
    background-color: ${props => props.theme.colors.white};
    padding: 24px;
    border-radius: 16px;
    box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
    align-items: center;
    max-width: 700px;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;

    @media (min-width: 601px) and (max-width: 650px) {
        width: 93%;
        margin: auto;
    }
`;
export const TpvHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;º
  gap: 4px;
`;

export const PepperTpvContainer = styled.div`
    padding: 12px 25px;
    -webkit-box-align: center;
    border-radius: 8px;
    width: 100%;
    max-width: 700px;
    margin-top: 16px;
    display: flex;
    z-index: 99;
    background-color: #fff;
    flex-direction: column;
    align-items: center;
    min-height: 450px;
   @media (max-width: 950px) {
    padding: 12px 0px;
   }
    
    @media (max-width: 650px) {
      width: 93%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 auto;
      margin-top: 10px;
      padding: 12px 0px;
    }
`;